import { Button, Input, message, Modal, Spin } from "antd";
import React from "react";
import useRequest from "../../../components/hooks/use-request";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import z from "zod";

const RemoveRestriction = ({
  open,
  onCancel,
  account,
  refetchAccount,
  restriction,
  refetchRestriction,
}: any) => {
  const userToken = localStorage.getItem("token");

  const { makeRequest, loading } = useRequest(
    `/users/${account?.id}/lift-restriction`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      reason: "",
    },
    resolver: zodResolver(
      z.object({
        reason: z.string().min(1, { message: "Reason is required" }),
      })
    ),
  });

  const onSubmit = async (data: any) => {
    const [response] = await makeRequest(data);
    if (response?.status === true) {
      message.success(response?.message);
      reset();
      refetchAccount();
      refetchRestriction();
      onCancel();
    } else {
      message.error(response?.message);
    }
  };

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={450}>
      <div>
        <p className="text-sm font-semibold">Remove restriction</p>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="mt-4 flex flex-col gap-4"
        >
          <div>
            <label htmlFor="amount" className="text-xs font-medium">
              Amount
            </label>
            <div className="flex items-center gap-2 border border-[#D0D5DD] rounded-lg p-2">
              <p className="text-sm font-semibold">₦{restriction?.amount}</p>
              <p className="text-xs text-[#8B8B8C]">
                {restriction?.type === "partial" ? "Partial" : "Full"}
              </p>
            </div>
          </div>
          <Controller
            control={control}
            name="reason"
            render={({ field }) => (
              <div className="flex flex-col gap-2">
                <label htmlFor="reason" className="text-xs font-medium">
                  Reason for removing restriction
                </label>
                <textarea
                  {...field}
                  id="reason"
                  className="w-full border border-[#D0D5DD] rounded-lg p-2 h-24 resize-none"
                />
              </div>
            )}
          />
          <Button
            type="primary"
            htmlType="submit"
            disabled={loading}
            loading={loading}
            className="bg-[#0979A1] text-[#fff] px-4 py-2 rounded-lg text-sm font-medium w-full hover:w-full"
          >
            Remove restriction
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default RemoveRestriction;
